import IconLoadingWave from "../icons/IconLoadingWave";

export default function Button({
  icon,
  text,
  onClicked = () => {},
  type = "normal",
  loading = false,
  disabled = false,
  active = false,
}) {
  return (
    <button
      className={`${loading === true ? "loading" : ""} ${
        disabled === true ? "disabled" : ""
      } ${active === true ? "active" : ""} ${type}`}
      onClick={() => (disabled || loading ? null : onClicked())}
    >
      {icon && !loading && icon}
      {loading && <IconLoadingWave color="white" />}
      {text}
    </button>
  );
}
